const EVENTS = Object.freeze({
  VIEWED_LOADED_CHECKOUT_WIDGET: 'Viewed Loaded Checkout Widget',
  VIEWED_UPDATED_CHECKOUT_WIDGET: 'Viewed Updated Checkout Widget',
  VIEWED_CHECKOUT_WIDGET_LOADING_ERROR: 'Viewed Checkout Widget Loading Error',
  VIEWED_DECLINED_CHECKOUT_WIDGET: 'Viewed Declined Checkout Widget',
});

export default EVENTS;
